import React, {useState , useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import PropertyList from "./allProperties";
import FinalBookForm from "./finalBookForm.jsx";

// import BookingEmailVerificationPopup from "./BookingEmailVerificationPopup.jsx";


import properties from "./Yovho.properties.json";
import SearchBar from "./SearchBar";
import "./Book.css";
import "./BookingSteps.css";

const Book = ({}) => {
   
  const navigate = useNavigate();

  const [property , setProperty] = useState({})
  const [BooingDate , setBooingDate] = useState({})

  const [showPopup, setShowPopup] = useState(false);


    const steps = [
    { id: 1, label: "Your Selection" },
    { id: 2, label: "Your Details" },
    { id: 3, label: "Finish Booking" },
  ];


  useEffect(() => {
    window.scrollTo(0, 0);
    let property1 = JSON.parse(localStorage.getItem("Selected_Room"))
    let BooingData = JSON.parse(localStorage.getItem("BookingDate"))
    setProperty(property1)
    setBooingDate(BooingData)
    console.log(property1)
  }, []);


  return (
    <div>
      <br />
<div className="steps-container">
      {steps.map((step, index) => (
        <div key={step.id} className="step-item">
          <div
            className={`step-circle ${
              2 >= step.id ? "active" : ""
            }`}
          >
            {step.id}
          </div>
          <span
            className={`step-label ${
              2 >= step.id ? "active-label" : ""
            }`}
          >
            {step.label}
          </span>
          {index < steps.length - 1 && (
            <div
              className={`step-line ${
                2 > step.id ? "active-line" : ""
              }`}
            ></div>
          )}
        </div>
      ))}
    </div>


      <div className="container">
        <div className="row">
          <div className="col-lg-3">

  <div className="Room_booking-summary">

    {/* Hotel Info */}
        <div className="Room_hotel-card">
        <img
            src={property.property?.images[0]}
            alt="Hotel"
            className="Room_hotel-img"
        />
        <div className="Room_hotel-info">
            <span>{"★".repeat(property.property?.stars || 4)}</span>
            <h5>{property.property?.propertyName}</h5>
            <p className="Room_hotel-location">{property.property?.address}</p>
            <span className="Room_hotel-rating"> <span>4.6</span>  Pleasant · 606 reviews</span>
        </div>
        </div>
      <hr/>
        {/* Booking Details */}
        <div className="Room_card-box">
        <h6>Your booking details</h6>
        <div className="d-flex justify-content-between">
            <div style={{borderRight:"1px solid grey",width:"50%"}}>
            <p className="Room_title">Check-in</p>
            <p className="Room_para">{BooingDate ? new Date(BooingDate.checkIn).toLocaleDateString("en-US", { weekday: "short" }) : ""}, {property.bookingDate?.startDate}
              {/* Mon, Sep 22, 2025 */}
              </p>
            {/* <p className="Room_para1">{property.property?.checkIn.from}12:30 PM – {property.property?.checkIn.until}2:00 PM</p> */}
            </div>
            <div style={{paddingLeft:"15px"}}>
            <p className="Room_title">Check-out</p>
            <p className="Room_para">{BooingDate? new Date(BooingDate.checkOut).toLocaleDateString("en-US", { weekday: "short" }) : ""}, {property.bookingDate?.endDate}
              {/* Mon, Sep 22, 2025 */}
              </p>
            {/* <p className="Room_para1">{property.property?.checkOut.from} 12:00 PM – {property.property?.checkOut.until}1:30 PM</p> */}
            </div>
        </div>
        <hr />
        <h6>You selected</h6>


{/* <p><strong>1 night, 1 room for 2 adults</strong></p> */}
        <p>
  <strong>
    {Math.ceil(
      (new Date(BooingDate?.checkOut) - new Date(BooingDate?.checkIn)) / (1000 * 60 * 60 * 24)
    )}{" "}
    night{Math.ceil((new Date(BooingDate?.checkOut) - new Date(BooingDate?.checkIn)) / (1000 * 60 * 60 * 24)) > 1 ? "s" : ""},{" "}
    {property?.noOfRooms} room{property?.noOfRooms > 1 ? "s" : ""} for {BooingDate?.adults} adult{BooingDate?.adults > 1 ? "s" : ""}
    {BooingDate?.children > 0 ? ` and ${BooingDate?.children} child${BooingDate?.children > 1 ? "ren" : ""}` : ""}
  </strong>
</p>

        <p>{property?.stayDurationInDays} night{property?.noOfRooms > 1 ? "s" : ""}  × {property.Room?.roomDetails.customName}</p>
        <a style={{color : "blue"}} href="/searchresults">Change your selection</a>
        </div>

        {/* Price Summary */}
        <div className="Room_card-box price-box">
        <h6>Your price summary</h6>
        <div className="Room_price-main" style={{fontSize:"22px"}}>
            <span className="Room_price-label"> <b>Price</b> </span>
            <span className="Room_price-amount"> <b style={{marginLeft:"5px"}}>PKR {property?.totalPrice}</b> </span>
        </div>
        <p className="Room_tax-note">+PKR {property?.taxs} taxes and fees<br/>
        {/* In property currency: US$135 */}
        </p>
        </div>

        {/* Price Info */}
        <div className="Room_card-box">
        <h6>Price information</h6>
        <ul className="Room_price-info">
            <li>Excludes PKR {property?.taxs} in taxes and fees</li>
            <li>15% Tax — PKR {property?.taxs}</li>
            {/* <li>This price is converted to show you the approximate cost in PKR. You’ll pay in USD. The exchange rate might change before you pay.</li> */}
            {/* <li>Keep in mind your card issuer may charge a foreign transaction fee.</li> */}
        </ul>
        </div>


        <div className="Room_card-box">
        <h6>Your payment schedule
</h6>
        <ul className="Room_price-info">
            <li style={{color :"#008009"}}>No payment today. You'll pay when you stay.
</li>
            {/* <li>15% Tax — PKR 5,697.85</li>
            <li>This price is converted to show you the approximate cost in PKR. You’ll pay in USD. The exchange rate might change before you pay.</li>
            <li>Keep in mind your card issuer may charge a foreign transaction fee.</li> */}
        </ul>
        </div>

    </div>






          </div>
          <div className="col-lg-9">




            <FinalBookForm property={JSON.parse(localStorage.getItem("Selected_Room"))} />




          </div>
        </div>
      </div>
    </div>
  );
};

export default Book;
